// extracted by mini-css-extract-plugin
module.exports = {"normal":"Container-module--normal--3P8zo","large":"Container-module--large--oD6fF"};